import { Refresh } from '@mui/icons-material';
import { CircularProgress } from '@mui/material';
import { useState } from 'react';
import { Button, Identifier, useDataProvider, useNotify, useRefresh } from 'react-admin';
import type { GPDataProvider } from '../../DataProvider';
import { getJsonApiErrorDetail } from '../../utils';

interface RecalculateBudgetStatusButtonProps {
  merchantId?: Identifier;
}

export default function RecalculateBudgetStatusButton({
  merchantId,
}: RecalculateBudgetStatusButtonProps) {
  const dataProvider = useDataProvider<GPDataProvider>();
  const notify = useNotify();
  const refresh = useRefresh();
  const [isPending, setIsPending] = useState(false);

  const handleClick = async () => {
    if (merchantId == null) {
      notify('Save this merchant before recalculating budget status.', { type: 'warning' });
      return;
    }

    try {
      setIsPending(true);
      const result = await dataProvider.merchantRecalculateBudgetStatus(merchantId as Identifier);
      notify(
        `Budget status recalculated. Restored ${result.restoredClicks} over-budget click(s).`,
        { type: 'success' },
      );
      refresh();
    } catch (error) {
      notify(getJsonApiErrorDetail(error, 'Error recalculating budget status'), {
        type: 'warning',
      });
    } finally {
      setIsPending(false);
    }
  };

  return (
    <Button
      label="Recalculate Budget Status"
      variant="contained"
      color="primary"
      disabled={isPending}
      startIcon={isPending ? <CircularProgress size={16} /> : <Refresh fontSize="small" />}
      onClick={handleClick}
    />
  );
}
